export const signInAppBehaviorIds = {
    childrenSwitchRoom: 'CHILDREN_SWITCH_ROOM_IN_SIGNIN_APP',
    limitedData: 'LIMIT_DATA_IN_SIGNIN_APP',
    enableEmployeeCheckin: 'ENABLE_EMPLOYEE_CHECKIN',
    expectedPickupTime: 'EXPECTED_PICKUP_TIME',
    redesign: 'SIGN_IN_APP_REDESIGN',
};
